/**
 * Local copy of the venue enum + display labels for the public
 * marketplace site. Mirrors `@axon-trading/sdk:VENUES` exactly.
 *
 * Why a copy: the marketplace-web bundle stays SDK-free at runtime
 * (no viem / wagmi pulled in transitively). Tag normalization
 * happens at build time, so the browser only needs the venue
 * enum to render filter chips. ~10 lines of constants.
 *
 * Drift guard: `packages/sdk/test/taxonomy.test.ts` is the
 * canonical test surface. If you add a venue to the SDK enum,
 * also update this file (a CI invariant patch could enforce
 * exact byte-equality with `@axon-trading/sdk` at build time —
 * deferred until divergence becomes a real problem).
 */

export const VENUES = ["hyperliquid", "lighter"] as const;

export type VenueId = (typeof VENUES)[number];

export const VENUE_LABELS: Record<VenueId, string> = {
  hyperliquid: "Hyperliquid",
  lighter: "Lighter.xyz",
};

export function isVenue(v: string): v is VenueId {
  return (VENUES as readonly string[]).includes(v);
}
